import { axiosSolve, globalAxios, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    order_detail: {},
    order_status_id: 1,
    rider_list: [],
    order_detail_me: {},
    add_on_list_me: [],
    vehicle_list: [],
    store_type: [
      {
        store_type_id: 0,
        store_type_name_th: "ทุกประเภท",
      },
    ],
    store_list: [],
    product_by_store_list: [],
    option_by_product_list: [],
    fetchRiderListData: [],
    // PaymentAPI: Card Refunds
    card_refunds: [],
    card_refunds_count: 0,
    card_refunds_next: null,
    card_refunds_previous: null,
    card_refund_detail: null,
  },
  mutations: {
    getOrderDetail(state, data) {
      state.order_detail = data;
    },
    setOrderStatusID(state, ID) {
      state.order_status_id = ID;
    },
    getDataRider(state, data) {
      state.rider_list = data;
    },
    updateOrder(state, data) {
      Object.assign(state.order_detail, data);
    },
    getOrderDetailME(state, data) {
      state.order_detail_me = data;
    },
    getAddonME(state, data) {
      state.add_on_list_me = data;
    },
    getVehicleList(state, data) {
      state.vehicle_list = data;
    },
    getStoreType(state, data) {
      for (let val of data) {
        state.store_type.push(val);
      }
    },
    getStoreList(state, data) {
      state.store_list = data;
    },
    getProductByStore(state, data) {
      state.product_by_store_list = data;
    },
    getOptionByProduct(state, data) {
      state.option_by_product_list = data;
    },
    updateItem(state, data) {
      delete data.order_customer_address;
      Object.assign(state.order_detail, data);
      state.order_detail.order_customer_address.customer_address_order_id =
        state.order_detail.order_id;
    },
    createItem(state, data) {
      delete data.order_customer_address;
      Object.assign(state.order_detail, data);
      state.order_detail.order_customer_address.customer_address_order_id =
        state.order_detail.order_id;
    },
    deleteItem(state, data) {
      delete data.order_customer_address;
      Object.assign(state.order_detail, data);
      state.order_detail.order_customer_address.customer_address_order_id =
        state.order_detail.order_id;
    },
    updateDataME(state, data) {
      state.order_detail_me = data;
    },
    resendOrder(state, data) {
      state.order_detail.order_resend_order = data;
    },
    resendOrderME(state, data) {
      state.order_detail_me.order_resend_order = data;
    },
    usePromotion(state, data) {
      Object.assign(state.order_detail, data);
    },
    usePromotionME(state, data) {
      Object.assign(state.order_detail_me, data);
    },
    deletePromotionFood(state) {
      state.order_detail.order_discount = null;
      state.order_detail.order_net_price =
        state.order_detail.order_net_price +
        state.order_detail.order_total_discount_price;
      state.order_detail.order_total_discount_price = 0;
    },
    deletePromotionME(state) {
      state.order_detail_me.order_discount = null;
      state.order_detail_me.order_net_price =
        state.order_detail_me.order_net_price +
        state.order_detail_me.order_total_discount_price;
      state.order_detail_me.order_total_discount_price = 0;
    },
    setRiderList(state, data) {
      state.fetchRiderListData = data;
    },
    // Card Refunds mutations
    setCardRefunds(state, payload) {
      state.card_refunds = Array.isArray(payload.data) ? payload.data : [];
      state.card_refunds_count = payload.count || 0;
      state.card_refunds_next = payload.next || null;
      state.card_refunds_previous = payload.previous || null;
    },
    setCardRefundDetail(state, payload) {
      state.card_refund_detail = payload || null;
    },
  },
  actions: {
    async fetchRiderList({ dispatch, commit }) {
      let url =
        backendVersion.version +
        "/weserve_for_business/get_list_rider_provider_wesmart/66";
      return globalAxios
        .get(url)
        .then((res) => {
          commit("setRiderList", res.data);
        })
        .catch((err) => {
          return false;
        });
    },
    async sentOrderToRider({ dispatch, commit }, payload) {
      let url =
        backendVersion.version +
        "/weserve_for_business/phuket/sent_order_to_rider_provider_wesmart";
      return globalAxios
        .put(url, payload)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return false;
        });
    },
    async ClearRiderinOrder({ dispatch, commit }, payload) {
      let url =
        backendVersion.version +
        `/weserve_for_business/phuket/clear_rider_in_order_provider_wesmart/${payload}`;
      return globalAxios
        .put(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return false;
        });
    },
    async InqueueOrderProvider({ dispatch, commit }, payload) {
      let url =
        backendVersion.version +
        `/weserve_for_business/phuket/inqueue_order_provider_wesmart/${payload}`;
      return globalAxios
        .put(url)
        .then((res) => {
          return true;
        })
        .catch((err) => {
          return false;
        });
    },
    async completeOrderProviderWesmart({ dispatch, commit }, payload) {
      let url =
        backendVersion.version +
        `/weserve_for_business/phuket/complete_order_provider_wesmart/${payload}`;
      return globalAxios
        .post(url, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return false;
        });
    },
    async cancelOrderProviderWesmart({ dispatch, commit }, payload) {
      let url =
        backendVersion.version +
        `/weserve_for_business/phuket/cancel_order_provider_wesmart/${payload}`;
      return globalAxios
        .put(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return false;
        });
    },
    async deletePromotion({ dispatch, rootState, commit, state }, form) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_deletePromotion + form.order_id; //backend#98
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (form.order_type == 1 || form.order_type == 3) {
          commit("deletePromotionFood");
          commit(
            "fetchOrderListBack/syncOrderFromDetail",
            state.order_detail,
            { root: true }
          );
        } else {
          commit("deletePromotionME");
          commit(
            "fetchOrderListBack/syncOrderFromDetail",
            state.order_detail_me,
            { root: true }
          );
        }
        return true;
      }
    },
    async usePromotionME(
      { commit, rootState, dispatch, state },
      { order_id, use_promo_code }
    ) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_usePromotion +
        order_id +
        "/" +
        use_promo_code;
      let form = {};
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        if (res.promotion_status == false) {
          return res;
        }
        commit("usePromotionME", res.data);
        commit(
          "fetchOrderListBack/syncOrderFromDetail",
          state.order_detail_me,
          { root: true }
        );
        return 2;
      }
    },
    async usePromotion(
      { commit, rootState, dispatch, state },
      { order_id, use_promo_code }
    ) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_usePromotion +
        order_id +
        "/" +
        use_promo_code;
      let form = {};
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        if (res.promotion_status == false) {
          return res;
        }
        commit("usePromotion", res.data);
        commit(
          "fetchOrderListBack/syncOrderFromDetail",
          state.order_detail,
          { root: true }
        );
        return 2;
      }
    },
    async updateDataME({ commit, rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_updateDataME + form.order_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("updateDataME", res);
        commit(
          "fetchOrderListBack/syncOrderFromDetail",
          { ...form, ...res },
          { root: true }
        );
        commit("fetchOrderListBack/updateOrder", null, {
          root: true,
        });

        return 2;
      }
    },
    async deleteItem({ commit, rootState, dispatch }, form) {
      let url =
        backendVersion.version +
        "/" +
        rootState.backOffice.province +
        "/delete/backoffice/online/order/" +
        form.order_detail_order_id +
        "/order_detail/" +
        form.order_detail_id;
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      };

      return axiosSolve
        .delete(url, axiosConfig)
        .then((res) => {
          if (res.data.msg == 0 || res.data.msg == 1) {
            dispatch("checkMessage", res.data.msg, { root: true });
          }

          commit("deleteItem", res.data);

          return 1;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });

          return 0;
        });
    },
    async createItem({ commit, rootState, dispatch }, form) {
      let url = rootState.api_urls.fetchOrderDetailBack_createItem;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 0;
      } else {
        commit("createItem", res);
        return 1;
      }
    },
    async updateItem({ state, commit, rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_updateItem +
        form.order_detail_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("updateItem", res);
        return 2;
      }
    },
    async getOptionByProduct(
      { state, commit, rootState, dispatch },
      product_id
    ) {
      state.option_by_product_list = null;
      let url =
        rootState.api_urls.fetchOrderDetailBack_getOptionByProduct + product_id;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getOptionByProduct", res);
        return res;
      }
    },
    async getProductByStore({ state, commit, rootState, dispatch }, store_id) {
      state.product_by_store_list = [];
      state.option_by_product_list = [];
      let url =
        rootState.api_urls.fetchOrderDetailBack_getProductByStore + store_id;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getProductByStore", res);
        return res;
      }
    },
    async getStoreList({ state, commit, rootState, dispatch }) {
      state.product_by_store_list = [];
      state.option_by_product_list = [];
      state.store_list = [];
      let url = rootState.api_urls.fetchOrderDetailBack_getStoreList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getStoreList", res);
        return true;
      }
    },
    async getStoreType({ state, commit, rootState, dispatch }) {
      state.store_type = [
        {
          store_type_id: 0,
          store_type_name_th: "ทุกประเภท",
        },
      ];
      let url = rootState.api_urls.fetchOrderDetailBack_getStoreType;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getStoreType", res);
        return true;
      }
    },
    async getVehicleList({ commit, rootState, dispatch }) {
      commit("getVehicleList", []);
      let url = rootState.api_urls.fetchOrderDetailBack_getVehicleList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getVehicleList", res);
        return true;
      }
    },
    async getAddonME({ commit, rootState, dispatch }, vehicle_id) {
      commit("getAddonME", []);
      let url = rootState.api_urls.fetchOrderDetailBack_getAddonME + vehicle_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getAddonME", res);
        return true;
      }
    },
    async getOrderDetailME({ commit, rootState, dispatch }, order_id) {
      commit("getOrderDetailME", {});
      let url =
        rootState.api_urls.fetchOrderDetailBack_getOrderDetailME + order_id;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getOrderDetailME", res);
        return true;
      }
    },
    async updateRider({ commit, rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_updateRider + form.order_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: form.form_rider },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (
          "msg" in res &&
          res.msg == false &&
          "data" in res &&
          res.data.status == false &&
          "countdown" in res.data
        ) {
          alert("คุณจะเปลี่ยน Rider ได้ภายใน" + res.data.countdown + " วินาที");
          return false;
        }
        commit(
          "fetchOrderListBack/syncOrderFromDetail",
          { order_id: form.order_id, ...form.form_rider },
          { root: true }
        );
        return true;
      }
    },
    async updateOrder({ commit, rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_updateOrder + form.order_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("updateOrder", res);
        commit(
          "fetchOrderListBack/syncOrderFromDetail",
          { ...form, ...res },
          { root: true }
        );
        commit("fetchOrderListBack/updateOrder", null, {
          root: true,
        });
        return 2;
      }
    },
    async resendOrderME({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_resendOrderME +
        config_path.order_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: {} },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("resendOrderME", res);
        return true;
      }
    },
    async resendOrder({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchOrderDetailBack_resendOrder +
        config_path.order_id +
        "/" +
        config_path.order_status_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: {} },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("resendOrder", res);
        return true;
      }
    },
    async getDataRider({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchOrderDetailBack_getDataRider;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getDataRider", res);
        return res;
      }
    },
    async getOrderDetail({ state, commit, rootState, dispatch }, order_id) {
      state.order_detail = {};
      let url =
        rootState.api_urls.fetchOrderDetailBack_getOrderDetail + order_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getOrderDetail", res);
        return true;
      }
    },
    async getOrderDetailReceipt({ state, commit, rootState, dispatch }, url) {
      state.order_detail = {};

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return "Err message : " + err;
      } else {
        return res;
      }
    },
    async fetchOrderWesmartDetailById({ dispatch }, payload) {
      let url = `/api/v1/${payload.province}/wesmart/orderdetail/${payload.orderId
        }`;
      return globalAxios
        .get(url)
        .then((res) => {
          // console.log(res)
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    async wesmartCancelOrderByOrderCode({ dispatch, commit }, payload) {
      let url = `/api/v1/${payload.province}/CancelOrderInWesmart/${payload.orderCode
        }`;
      console.log("cancel order");
      console.log(payload);
      console.log(url);
      return globalAxios
        .get(url)
        .then((res) => {
          commit(
            "fetchOrderListBack/cancelOrderWesmartInStatus",
            { code: payload.orderCode, status: payload.orderStatus },
            { root: true }
          );
          // console.log(res)
          return true;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async wesmartCompleteOrderByOrderCode({ dispatch }, payload) {
      let url = `/api/v1/${payload.province}/wesmart/ordercomplete/${payload.order_code
        }`;

      // console.log("wesmart_order_complete : ", url)
      // console.log("payload img ", payload.img.length)
      // console.log("payload id ", payload.orderId)

      return globalAxios
        .put(url, {
          order_id: parseInt(payload.order_id),
          img: `data:image/jpeg;base64,${payload.img}`,
        })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    async wesmartSelectRider({ dispatch }, payload) {
      // console.log("REVOKE RIDER", payload)
      let url = `/api/v1/${payload.province
        }/PickRiderByIdInCaseDuplicateRider/${payload.orderCode}/${payload.riderId
        }`;
      // console.log(url)
      return globalAxios
        .get(url)
        .then((res) => {
          console.log("wesmart revoking rider = > ", res);
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    async sendOrderAndRiderIdToWesmart({ dispatch }, payload) { },

    async getOrderChatSetting({ dispatch }, { province }) {
      let url = backendVersion.version + `/${province}/chat_setting`;
      return globalAxios
        .get(url)
        .then((res) => {
          if (res.status === false) return false;
          return res.data.chat_provider;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    // PaymentAPI: Card Refunds
    async fetchCardRefunds({ commit, dispatch }, params = {}) {
      // Build PaymentAPI base path; default to same API version root if no prefix provided
      const paymentPrefix = process.env.VUE_APP_PAYMENT_API_PREFIX || "/payment"; // e.g. "/PaymentAPI"
      const url = `${backendVersion.version}${paymentPrefix}/card/refunds`;

      return globalAxios
        .get(url, { params: { ...params } })
        .then((res) => {
          // res follows envelope: { msg, data, count, next, previous }
          if (res && res.msg === true) {
            commit("setCardRefunds", res);
            return res.data;
          }
          // handle unified false
          dispatch("checkMessage", res.msg || 2, { root: true });
          return false;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    async fetchCardRefundDetail({ commit, dispatch }, refundId) {
      const paymentPrefix = process.env.VUE_APP_PAYMENT_API_PREFIX || "/payment";
      const url = `${backendVersion.version}${paymentPrefix}/card/refunds/${refundId}`;

      return globalAxios
        .get(url)
        .then((res) => {
          if (res && res.msg === true) {
            commit("setCardRefundDetail", res.data);
            return res.data;
          }
          dispatch("checkMessage", res.msg || 2, { root: true });
          return false;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    // PaymentAPI: Card Payments search (for refund creation flow)
    async searchCardPayments({ dispatch }, params = {}) {
      const paymentPrefix = process.env.VUE_APP_PAYMENT_API_PREFIX || "/payment";
      const url = `${backendVersion.version}${paymentPrefix}/card/payments/search`;

      return globalAxios
        .get(url, { params })
        .then((res) => {
          if (res && res.msg === true) {
            return res.data || [];
          }
          dispatch("checkMessage", res.msg || 2, { root: true });
          return false;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    // PaymentAPI: Create/queue a refund
    async createCardRefund({ dispatch }, payload) {
      const paymentPrefix = process.env.VUE_APP_PAYMENT_API_PREFIX || "/payment";
      const url = `${backendVersion.version}${paymentPrefix}/card/refunds/create`;

      return globalAxios
        .post(url, payload)
        .then((res) => {
          if (res && res.msg === true) {
            return res.data;
          }
          // unify false handling, and try to surface error message if present
          const msg = (res && (res.error || res.msg)) || 2;
          dispatch("checkMessage", msg, { root: true });
          return false;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {
    getDataRiderWallet(state) {
      let rider_list_temp = JSON.parse(JSON.stringify(state.rider_list));
      for (let val of rider_list_temp) {
        let wallet = parseFloat(val.wallet).toFixed(2);
        wallet = wallet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        let isReady = val.app_status == 1 ? "พร้อมรับงาน" : "ไม่พร้อมรับงาน";

        val.rider_full_name_temp =
          val.rider_full_name + " ( " + isReady + " ===> " + wallet + " ฿  )";
      }
      return rider_list_temp;
    },
  },
};
